import { render, staticRenderFns } from "./teaCourseFile.vue?vue&type=template&id=4c6d9bc2&scoped=true"
import script from "./teaCourseFile.vue?vue&type=script&lang=js"
export * from "./teaCourseFile.vue?vue&type=script&lang=js"
import style0 from "./teaCourseFile.vue?vue&type=style&index=0&id=4c6d9bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d9bc2",
  null
  
)

export default component.exports